export default __webpack_public_path__ + "static/uchicago-344a989a64f31ac2ceafd90fcb20a034.svg";